import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

// PERFORMANCE: Memoized to prevent re-renders when props don't change
export const Card = React.memo<CardProps>(({
  children,
  className = '',
  padding = 'md',
}) => {
  return (
    <div
      className={`
        bg-white rounded-lg shadow-md border border-neutral-200
        ${paddingClasses[padding]}
        ${className}
      `}
    >
      {children}
    </div>
  );
});

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

// PERFORMANCE: Memoized Card subcomponents
export const CardHeader = React.memo<CardHeaderProps>(({ children, className = '' }) => {
  return (
    <div className={`mb-4 ${className}`}>
      {children}
    </div>
  );
});

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle = React.memo<CardTitleProps>(({ children, className = '' }) => {
  return (
    <h3 className={`text-xl font-semibold text-neutral-900 ${className}`}>
      {children}
    </h3>
  );
});

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export const CardContent = React.memo<CardContentProps>(({ children, className = '' }) => {
  return <div className={className}>{children}</div>;
});
